import { BPanel, Breadcrumb, Form, FormGroup, FormControl, Col, ControlLabel, Button } from '@sketchpixy/rubix';
import { Link, withRouter } from 'react-router';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { Reactive } from '../common/Reactive.mixin';

import { UserSchema } from '../../collections/users/users';
import { updatePassword } from '../../collections/users/methods';
import MgfForm from '../common/mgfForm';
import { SpecialPricesComponent } from './components/SpecialPrices';

@Reactive({
	subscriptions: ["users"]
})
@withRouter
export default class PartnerEditPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isReady && !this.props.isReady) {
			this.setState({
				user: Meteor.users.findOne({_id: this.props.params.id})
			});
		}
	}

	handleSubmit() {
		let params = {};

		params.attributes = {};
		_.each(this.refs, (ref, key) => {
			params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();   
		});

		Meteor.users.update(this.state.user._id, { "$set": params.attributes });

		window.location.replace('/partners');
	}

	render() {
		return (
			<div>
				{ this.props.isReady &&
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/partners">Partenaires</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						{this.state.user.profile.firstName} {this.state.user.profile.lastName}
					</Breadcrumb.Item>
				</Breadcrumb>
				}
				
				{ this.props.isReady &&
				<BPanel header="Modifier le partenaire">
					<Form horizontal onSubmit={this.handleSubmit.bind(this)}>

						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Adresse
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="profile.street" defaultValue={this.state.user.profile.street} />
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Code postal et ville
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="profile.city" defaultValue={this.state.user.profile.city} />
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Téléphone
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="profile.phone" defaultValue={this.state.user.profile.phone} />
							</Col>
						</FormGroup>

						<hr/>

						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Nombre de commande offerte
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="profile.freeFlights" defaultValue={this.state.user.profile.freeFlights} />
							</Col>
						</FormGroup>


						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Type de facturation
							</Col>
							<Col sm={10}>
								<FormControl componentClass="select" placeholder="select" ref="profile.billType" defaultValue={this.state.user.profile.billType} >
									<option value="standard">Standard</option>
									<option value="groupe">Groupé</option>
								</FormControl>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Accès au calendrier
							</Col>
							<Col sm={10}>
								<FormControl componentClass="select" placeholder="select" ref="profile.accessToCalendar" defaultValue={this.state.user.profile.accessToCalendar} >
									<option value="">Non</option>
									<option value="true">Oui</option>
								</FormControl>
							</Col>
						</FormGroup>

						<hr/>

						<FormGroup controlId="formHorizontalPassword">
							<SpecialPricesComponent user={this.state.user}></SpecialPricesComponent>
						</FormGroup>

						<FormGroup>
							<Col smOffset={2} sm={10}>
								<Button onClick={::this.handleSubmit}>
									Enregistrer
								</Button>
							</Col>
						</FormGroup>
					</Form>
				</BPanel>
				}	
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/PartnerEdit.page.js
 **/